import React, { PureComponent } from 'react';

/**
 * 商品资料预览商品
 */
export class PreviewProductBtn extends PureComponent<any, any> {

    render() {
        const { row: { id } } = this.props;
        const url = ENV.PREVIEW_PRODUCT_URL + id;
        
        return (
            <a target="_blank" href={url} style={{marginRight: 10}}>
                预览
            </a>
        );
    }
}
